import { render, staticRenderFns } from "./v-avatar.vue?vue&type=template&id=686697f6&scoped=true"
import script from "./v-avatar.vue?vue&type=script&lang=ts"
export * from "./v-avatar.vue?vue&type=script&lang=ts"
import style0 from "./v-avatar.vue?vue&type=style&index=0&id=686697f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686697f6",
  null
  
)

export default component.exports